import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class ChampService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	getClientList(callback) {
		const url = "/champ-app/api/champ/clients";
		this._restClient.exec_get(url, callback);
	}

	getActiveUserSessions(clientId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/userCount`;
		this._restClient.exec_get(url, callback);
	}

	getSystemHealth(clientId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/health`;
		this._restClient.exec_get(url, callback);
	}

	getServices(clientId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/services`;
		this._restClient.exec_get(url, callback);
	}

	restartService(clientId, service, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/restartService/${service}`;
		this._restClient.exec_get(url, callback);
	}

	getTask(clientId, taskId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/task/${taskId}`;
		this._restClient.exec_get(url, callback);
	}

	getClientUsers(clientId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/users`;
		this._restClient.exec_get(url, callback);
	}

	getApplications(clientId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/applications`;
		this._restClient.exec_get(url, callback);
	}

	logoutUser(clientId, userId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/users/${userId}/logout`;
		this._restClient.exec_get(url, callback);
	}

	unlockUser(clientId, userId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/users/${userId}/unlock`;
		this._restClient.exec_put(url, null, callback);
	}

	graphql(clientId, graphqlQuery, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/graphql`;
		const body = JSON.stringify({
			query: graphqlQuery
		});
		this._restClient.exec_post(url, body, callback);
	}

	streamConnections(callback) {
		const args = {};
		return this._rc.subscribe("champ-app", "/champ/clients", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	verifySSL(clientId, certContent, keyContent, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/ssl/verify`;
		const body = JSON.stringify({
			cert: certContent,
			key: keyContent
		});
		this._restClient.exec_post(url, body, callback);
	}

	updateSSL(clientId, certContent, keyContent, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/ssl/update`;
		const body = JSON.stringify({
			cert: certContent,
			key: keyContent
		});
		this._restClient.exec_post(url, body, callback);
	}

	decryptPassword(clientId, encryptedPassword, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/decrypt-password`;
		const body = JSON.stringify({
			encryptedPassword: encryptedPassword
		});
		this._restClient.exec_post(url, body, callback);
	}

	getEcoSettings(clientId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/ecoSettings`;
		this._restClient.exec_get(url, callback);
	}
	
	getEcoSettingOptions(clientId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/ecoSettingOptions`;
		this._restClient.exec_get(url, callback);
	}

	updateEcoSettings(clientId, setting, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/ecoSettings`;
		const body = JSON.stringify({
			setting: setting
		});
		this._restClient.exec_put(url, body, callback);
	}

	addEcoSetting(clientId, setting, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/ecoSettings`;
		const body = JSON.stringify({
			setting: setting
		});
		this._restClient.exec_post(url, body, callback);
	}

	deleteEcoSetting(clientId, settingId, callback) {
		const url = `/champ-app/api/champ/client/${clientId}/ecoSettings/${settingId}`;
		this._restClient.exec_delete(url, callback);
	}
}